import styled from 'styled-components';

export const FrameBox = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 1 1 auto;
  min-height: 0;
  overflow: hidden;
  background: ${({ theme }) => theme.colors.surface};
`;

export const FrameNotice = styled.p`
  max-width: 420px;
  margin: 0;
  padding: 24px;
  text-align: center;
  ${({ theme }) => theme.font.bodyMedium};
  color: ${({ theme }) => theme.colors.onSurfaceVariant};
`;
